import {Grid , Typography , Card , CardActionArea, CardMedia , CardContent } from '@mui/material';
import TvIcon from '@mui/icons-material/Tv';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import EngineeringIcon from '@mui/icons-material/Engineering';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import '../App.css';

function Services(){
    return(
        <Grid container rowSpacing={1} columnSpacing={{xs : 1 , sm : 1 , md : 1}} style={{marginTop : '8em'}} id="services">
            <Grid item xs={12}>
                        <Typography variant="h6" component='div' 
                            style={{textAlign : 'center'  , color : '#a1a1a1'}}
                        >
                            What I Offer
                        </Typography>
            </Grid>
            <Grid container rowSpacing={3}  columnSpacing={3} style={{marginTop : '6em'}}>
            <Grid item xs={6} md={4} >
                <Card style={{border : '1px  black'}}>
                    <CardActionArea >
                        <CardMedia style={{textAlign : 'center'}}>
                            <TvIcon style={{width : '100px' , fontSize : '100px' , color : '#a1a1a1'}}/>
                        </CardMedia>
                        <CardContent >
                            <Typography  variant="h5" component="div" textAlign='center'>
                                Front End Web Developement
                            </Typography>
                            {/* <Typography style={{marginTop : '1em'}} variant="body2" color="text.secondary" textAlign='center'>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec eget aliquet mauris. Pellentesque consequat tellus vitae urna euismod, sed pharetra eros vulputate. 
                            </Typography> */}
                        </CardContent>
                    </CardActionArea>
                </Card>
            </Grid>
            <Grid item xs={6} md={4} >
                <Card>
                    <CardActionArea >
                        <CardMedia style={{textAlign : 'center'}}>
                            <ShoppingCartIcon style={{width : '100px' , fontSize : '100px', color : '#a1a1a1'}}/>
                        </CardMedia>
                        <CardContent >
                            <Typography  variant="h5" component="div" textAlign='center'>
                                E-Commerce Website
                            </Typography>
                            {/* <Typography style={{marginTop : '1em'}} variant="body2" color="text.secondary" textAlign='center'>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec eget aliquet mauris. Pellentesque consequat tellus vitae urna euismod, sed pharetra eros vulputate. 
                            </Typography> */}
                        </CardContent>
                    </CardActionArea>
                </Card>
            </Grid>
            <Grid item xs={6} md={4} >
                <Card>
                    <CardActionArea >
                        <CardMedia style={{textAlign : 'center'}}>
                            <PhoneAndroidIcon style={{width : '100px' , fontSize : '100px', color : '#a1a1a1'}} />
                        </CardMedia>
                        <CardContent >
                            <Typography  variant="h5" component="div" textAlign='center'>
                                Responsive Website
                            </Typography>
                            {/* <Typography style={{marginTop : '1em'}} variant="body2" color="text.secondary" textAlign='center'>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec eget aliquet mauris. Pellentesque consequat tellus vitae urna euismod, sed pharetra eros vulputate. 
                            </Typography> */}
                        </CardContent>
                    </CardActionArea>
                </Card>
            </Grid>
            <Grid item xs={6} md={4} >
                <Card>
                    <CardActionArea >
                        <CardMedia style={{textAlign : 'center'}}>
                            <CoPresentIcon style={{width : '100px' , fontSize : '100px', color : '#a1a1a1'}} />
                        </CardMedia>
                        <CardContent >
                            <Typography  variant="h5" component="div" textAlign='center'>
                                Portfolio Website
                            </Typography>
                            {/* <Typography style={{marginTop : '1em'}} variant="body2" color="text.secondary" textAlign='center'>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec eget aliquet mauris. Pellentesque consequat tellus vitae urna euismod, sed pharetra eros vulputate. 
                            </Typography> */}
                        </CardContent>
                    </CardActionArea>
                </Card>
            </Grid>
            <Grid item xs={6} md={4} >
                <Card>
                    <CardActionArea >
                        <CardMedia style={{textAlign : 'center'}}>
                            <EngineeringIcon style={{width : '100px' , fontSize : '100px', color : '#a1a1a1'}} />
                        </CardMedia>
                        <CardContent >
                            <Typography  variant="h5" component="div" textAlign='center'>
                                Fixing Bugs
                            </Typography>
                            {/* <Typography style={{marginTop : '1em'}} variant="body2" color="text.secondary" textAlign='center'>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec eget aliquet mauris. Pellentesque consequat tellus vitae urna euismod, sed pharetra eros vulputate. 
                            </Typography> */}
                        </CardContent>
                    </CardActionArea>
                </Card>
            </Grid>
            <Grid item xs={6} md={4}>
                <Card>
                    <CardActionArea >
                        <CardMedia style={{textAlign : 'center'}}>
                            <MoreHorizIcon style={{width : '100px' , fontSize : '100px', color : '#a1a1a1'}} />
                        </CardMedia>
                        <CardContent >
                            <Typography  variant="h5" component="div" textAlign='center'>
                                And More
                            </Typography>
                            {/* <Typography variant="body2" color="text.secondary" textAlign='center' style={{marginTop : '1em'}}>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec eget aliquet mauris. Pellentesque consequat tellus vitae urna euismod, sed pharetra eros vulputate. 
                            </Typography> */}
                        </CardContent>
                    </CardActionArea>
                </Card>
            </Grid>
            </Grid>
        </Grid>
    )
}

export default Services;